import { render, staticRenderFns } from "./TheBreadcrumbs.vue?vue&type=template&id=c5031b2c"
import script from "./TheBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./TheBreadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports